import { generateRequest } from '.';

export const Action = {
  VehicleProfile: {
    CreateVehicleProfilePending: 'CreateVehicleProfile_PENDING',
    CreateVehicleProfileCompleted: 'CreateVehicleProfile_FULFILLED',
    CreateVehicleProfileFailed: 'CreateVehicleProfile_FAILED',
    UpdateVehicleProfilePending: 'UpdateVehicleProfile_PENDING',
    UpdateVehicleProfileCompleted: 'UpdateVehicleProfile_FULFILLED',
    UpdateVehicleProfileFailed: 'UpdateVehicleProfile_FAILED',
    FetchVehicleProfilePending: 'FetchVehicleProfile_PENDING',
    FetchVehicleProfileCompleted: 'FetchVehicleProfile_FULFILLED',
    FetchVehicleProfileFailed: 'FetchVehicleProfile_FAILED',
    DeleteVehicleProfilePending: 'DeleteVehicleProfile_PENDING',
    DeleteVehicleProfileCompleted: 'DeleteVehicleProfile_FULFILLED',
    DeleteVehicleProfileFailed: 'DeleteVehicleProfile_FAILED',
    ResetSavingStatus: 'ResetSavingStatus',
    ResetSelectionStatus: 'ResetSelectionStatus',
  },
};

export const createVehicleProfile = body => generateRequest({
  method: 'POST',
  credentials: 'same-origin',
  endpoint: '/assets-v2/api/vehicles',
  body,
  types: [
    Action.VehicleProfile.CreateVehicleProfilePending,
    { type: Action.VehicleProfile.CreateVehicleProfileCompleted, meta: { vehicle: body } },
    Action.VehicleProfile.CreateVehicleProfileFailed,
  ],
});

export const fetchVehicleProfile = vehicleGuid => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}`,
  types: [
    Action.VehicleProfile.FetchVehicleProfilePending,
    Action.VehicleProfile.FetchVehicleProfileCompleted,
    Action.VehicleProfile.FetchVehicleProfileFailed,
  ],
});

export const deleteVehicleProfile = vehicleGuid => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${vehicleGuid}`,
  method: 'DELETE',
  credentials: 'same-origin',
  types: [
    Action.VehicleProfile.DeleteVehicleProfilePending,
    { type: Action.VehicleProfile.DeleteVehicleProfileCompleted, meta: { vehicleGuid } },
    Action.VehicleProfile.DeleteVehicleProfileFailed,
  ],
});

export const updateVehicleProfile = updates => generateRequest({
  endpoint: `/assets-v2/api/vehicles/${updates.guid}`,
  method: 'PUT',
  credentials: 'same-origin',
  body: updates,
  types: [
    Action.VehicleProfile.UpdateVehicleProfilePending,
    Action.VehicleProfile.UpdateVehicleProfileCompleted,
    Action.VehicleProfile.UpdateVehicleProfileFailed,
  ],
});

export const resetVehicleProfileSavingStatus = () => ({
  type: Action.VehicleProfile.ResetSavingStatus,
});

export const resetVehicleProfileSelectionStatus = () => ({
  type: Action.VehicleProfile.ResetSelectionStatus,
});
